module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v(_vm._s(_vm.msg))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-083f7ac6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Search.vue
// module id = 51
// module chunks = 1